var StatusViewController = (function () {
    function StatusViewController(env, $filter, DTS, $stateParams, $state, socket, $scope, admin, config, settings) {
        this.env = env;
        this.$filter = $filter;
        this.DTS = DTS;
        this.$stateParams = $stateParams;
        this.$state = $state;
        this.socket = socket;
        this.$scope = $scope;
        this.admin = admin;
        this.config = config;
        this.settings = settings;
        this.table = {};
        this.table.headers = [{
                'Main Status': '_link',
                'Description': 'desc'
            }];
    }
    StatusViewController.$inject = ['env', '$filter', 'DTS', '$stateParams', '$state', 'socket',
        '$scope', 'admin', 'config', 'settings'];
    return StatusViewController;
}());
var StatusViewComponent = (function () {
    function StatusViewComponent() {
        this.templateUrl = 'status-view.html';
        this.controllerAs = 'vm';
        this.controller = StatusViewController;
    }
    return StatusViewComponent;
}());
angular
    .module('application')
    .component('viewStatusSection', new StatusViewComponent());

//# sourceMappingURL=status.view.component.js.map
